// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Copy_wrapper___mgiZ"};